module.exports = __webpack_public_path__ + "assets/cab47926de03344902405047b11b6f56.mp3";